import { defaultUseCaseTranslator } from '../hooks/useUseCaseTranslate'

const FIELD_LABEL_KEYS = {
  user: 'errors.fieldUser',
  embed_url: 'errors.fieldMediaFile',
  'use_case_embeds.embed_url': 'errors.fieldMediaFile',
}

const KNOWN_ERROR_PATTERNS = {
  uniqueness: /has already been taken|already exists|already submitted|has already submitted/i,
  blank: /can't be blank|is required|must exist/i,
}

const formatFieldError = (field, errors, t = defaultUseCaseTranslator.t) => {
  const fieldLabel = FIELD_LABEL_KEYS[field] ? t(FIELD_LABEL_KEYS[field]) : field.replace(/_/g, ' ')
  const firstError = errors[0] || ''

  // Check for blank/required fields
  if (KNOWN_ERROR_PATTERNS.blank.test(firstError)) {
    return t('errors.fieldRequired', { field: fieldLabel })
  }

  // Default: combine field label with error message
  return `${fieldLabel} ${firstError}`
}

const isDuplicateSubmissionError = (errors) => {
  if (!errors || typeof errors !== 'object') return false

  // Check if user field has uniqueness error
  if (errors.user) {
    const userErrors = Array.isArray(errors.user) ? errors.user : [errors.user]
    return userErrors.some(err => KNOWN_ERROR_PATTERNS.uniqueness.test(err))
  }

  return false
}

export const parseValidationErrors = (error, translator = defaultUseCaseTranslator) => {
  const { t, tv } = translator

  // Check if we have response data
  if (!error?.response?.data) {
    return tv('errors.post')
  }

  const { data } = error.response

  // Check for duplicate submission (user uniqueness validation)
  if (isDuplicateSubmissionError(data)) {
    return tv('errors.alreadyShared')
  }

  // Parse validation errors
  const errorMessages = []

  Object.entries(data).forEach(([field, fieldErrors]) => {
    // Skip non-validation fields (like status, message, etc.)
    if (typeof fieldErrors === 'string' || !Array.isArray(fieldErrors)) return

    const message = formatFieldError(field, fieldErrors, t)
    errorMessages.push(message)
  })

  // If we found validation errors, return them
  if (errorMessages.length > 0) {
    return errorMessages.join('. ')
  }

  // Fallback: check if there's a general message field
  if (data.message && typeof data.message === 'string') {
    return data.message
  }

  if (data.error && typeof data.error === 'string') {
    return data.error
  }

  // Final fallback
  return tv('errors.postInvalid')
}

export { FIELD_LABEL_KEYS, KNOWN_ERROR_PATTERNS, formatFieldError, isDuplicateSubmissionError }
